import { render, staticRenderFns } from "./informationInquiryInfo.vue?vue&type=template&id=1dc81478&scoped=true"
import script from "./informationInquiryInfo.vue?vue&type=script&lang=js"
export * from "./informationInquiryInfo.vue?vue&type=script&lang=js"
import style0 from "./informationInquiryInfo.vue?vue&type=style&index=0&id=1dc81478&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc81478",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dc81478')) {
      api.createRecord('1dc81478', component.options)
    } else {
      api.reload('1dc81478', component.options)
    }
    module.hot.accept("./informationInquiryInfo.vue?vue&type=template&id=1dc81478&scoped=true", function () {
      api.rerender('1dc81478', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/rightPopup/inquiry/informationInquiryInfo.vue"
export default component.exports